import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../assets/images/propbank-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-6f4e01be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid d-flex justify-content-center p-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-bg" }, null, -1))
const _hoisted_3 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-4" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_5 = { class: "mt-5 p-4" }
const _hoisted_6 = {
  key: 0,
  class: "mb-3 text-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"color":"red"} }, [
  /*#__PURE__*/_createTextVNode(" Oppps... "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Brochure is not found or available or expired. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please confirm with your representative. ")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "no-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.errorCode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true),
          (!_ctx.errorCode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, "No content available."))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_Footer, { style: {"position":"absolute","bottom":"0","left":"0","right":"0"} })
  ], 64))
}